import React from "react";
import { createPortal } from "react-dom";

interface TransitionOverlayProps {
  open: boolean;
  title: string;
  subtitle?: string;
}

const TransitionOverlay: React.FC<TransitionOverlayProps> = ({
  open,
  title,
  subtitle,
}) => {
  if (!open) return null;

  const content = (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-label={title}
    >
      <div className="rounded-lg bg-background/95 px-8 py-6 text-center shadow-lg">
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-agri-green/30 border-t-agri-green" />
        <p className="text-lg font-medium text-foreground">{title}</p>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
    </div>
  );

  if (typeof document === "undefined") return content;
  return createPortal(content, document.body);
};

export default TransitionOverlay;
